import React from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Slide,
    Tab,
    Tabs,
    Tooltip,
    DialogActions,
    Button,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import TabPanel from "../../../Component/TabPanel/TabPanel";
import { TransitionProps } from "@mui/material/transitions";
import UserAndRoleSettings from "../UserAndRoles/UserAndRoleSettings";
import RolesAndPermissionsSettings from "../RolesAndPermissions/RolesAndPermissionsSettings";

// Interface for ManageRolesAndPermissionsDialog props
interface ManageRolesAndPermissionsDialogProps {
    open: boolean;
    onClose?: (state: boolean, action: string) => void;
    accessToken: string;
}

// Interface for ManageRolesAndPermissionsDialog state
interface ManageRolesAndPermissionsDialogState {
    tabValue: number;
    hasErrors: boolean;
    isLimitConfirm: boolean;
}

// Slide Transition for Dialog
const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// Main class component for ManageRolesAndPermissionsDialog
class ManageRolesAndPermissionsDialog extends React.Component<ManageRolesAndPermissionsDialogProps, ManageRolesAndPermissionsDialogState> {
    private UserAndRoleSettingsRef = React.createRef<UserAndRoleSettings>();
    private RolesAndPermissionsSettingsRef = React.createRef<RolesAndPermissionsSettings>();
    constructor(props: ManageRolesAndPermissionsDialogProps) {
        super(props);
        this.state = {
            tabValue: 0,
            isLimitConfirm: false,
            hasErrors: false
        };
    }

    // Tab change handler
    handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
        this.setState({ tabValue: newValue });
    };

    // Close the dialog
    handleClose = (action: string) => {
        this.props.onClose?.(false, action);
    };
    //On save click
    handleSave = () => {
        if (this.state.tabValue === 0 && this.UserAndRoleSettingsRef.current) {
            console.log("Updating UserAndRoleSettings state...");

            this.UserAndRoleSettingsRef.current.setState((prevState) => ({
                ...prevState,
                isUserAndRoleSettingSaved: true,
            }));
        } else if (this.state.tabValue === 1 && this.RolesAndPermissionsSettingsRef.current) {
            console.log("Updating RolesAndPermissionsSettings state...");

            this.RolesAndPermissionsSettingsRef.current.setState((prevState) => ({
                ...prevState,
                isRolesAndPermissionsSettingsSaved: true,
            }));
        }
    };

    // On save button click, check if there are any validation errors
    handleValidationChange = (hasErrors: boolean) => {
        console.log("Validation Status: ", hasErrors);
        this.setState({ hasErrors });
    };

    render() {
        const { tabValue, hasErrors } = this.state;
        const { open } = this.props;

        return (
            <Dialog
                TransitionComponent={Transition}
                open={open}
                onClose={() => this.handleClose("cancel")}
                fullWidth
                keepMounted
                maxWidth="md"
            >
                <DialogTitle sx={{ m: "12px 12px 0 12px", p: 2, position: "relative" }}>
                    <Tabs
                        value={tabValue}
                        onChange={this.handleTabChange}
                        aria-label="settings tabs"
                        indicatorColor="secondary"
                        textColor="primary"
                        sx={{ borderBottom: 1, borderColor: "divider" }}
                    >
                        <Tab label="Assign User Role" />
                        <Tab label="Create/update roles and Permission" />
                    </Tabs>
                    <Tooltip title="Close">
                        <IconButton
                            aria-label="close"
                            onClick={() => this.handleClose("cancel")}
                            sx={{
                                position: "absolute",
                                right: 0,
                                top: 0,
                                color: (theme) => theme.palette.grey[600],
                            }}
                        >
                            <Close />
                        </IconButton>
                    </Tooltip>
                </DialogTitle>
                <DialogContent sx={{ minHeight: "300px" }}>
                    <TabPanel value={tabValue} index={0}>
                        <UserAndRoleSettings
                            ref={this.UserAndRoleSettingsRef}
                            onValidationChange={this.handleValidationChange}
                            open={tabValue === 0}
                            onClose={(state: boolean, action: string) => {
                                this.handleClose(action);
                            }}
                            accessToken={this.props.accessToken} />
                    </TabPanel>
                    <TabPanel value={tabValue} index={1}>
                        <RolesAndPermissionsSettings
                            ref={this.RolesAndPermissionsSettingsRef}
                            onValidationChange={this.handleValidationChange}
                            open={tabValue === 0}
                            onClose={(state: boolean, action: string) => {
                                this.handleClose(action);
                            }}
                            accessToken={this.props.accessToken} />
                    </TabPanel>

                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleClose("cancel")}>Cancel</Button>
                    <Button
                        color="secondary"
                        variant="contained"
                        onClick={this.handleSave}
                        disabled={hasErrors}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default ManageRolesAndPermissionsDialog;